<template>
    <div
        v-bind="$attrs"
        :class="[$style['mds-loader'], classObject, sizeClass]"
        role="progressbar"
        :aria-valuetext="ariaValuetext"
        :data-mds-version="version"
    >
        <!-- inheritAttrs is false so v-bind must be below class for custom classes
        from user to be set properly -->
        <div v-for="n in 8" :key="n" :class="[$style['mds-loader__item'], $style[`mds-loader__item--${n}`]]"></div>
    </div>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsLoader',
        inheritAttrs: false,
        data() {
            return {
                version: `${name}-${version}`,
            };
        },
        props: {
            ariaValuetext: {
                type: String,
                default: 'Loading...',
                docs: {
                    validation: '',
                    description: 'Sets the loader `aria-valuetext` attribute.',
                },
            },
            onDark: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, changes component to on-dark styling.',
                },
            },
            size: {
                type: String,
                default: 'medium',
                validator(value) {
                    return ['small', 'medium', 'large'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `small`, `medium`, `large`.',
                    description: 'Sets the size of the loader.',
                },
            },
        },
        computed: {
            sizeClass() {
                return this.$style[`mds-loader--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @use './loader';
</style>
